@if (isLoad === false) {
  <cl-load></cl-load>
}

@if (visible === true) {
  <dx-popup
    [width]="'30%'"
    [height]="'auto'"
    [showTitle]="false"
    [dragEnabled]="false"
    [hideOnOutsideClick]="false"
    [showCloseButton]="false"
    class="add-item-popup"
    [resizeEnabled]="false"
    [(visible)]="visible"
    [toolbarItems]="popupToolbarItems"
  >
    <cl-work-page>
      <cl-work-page-header>
        <cl-work-page-header-content>
          <cl-work-page-header-content-title [showBack]="false">
            {{ 'globals/Information' | translate }}
          </cl-work-page-header-content-title>
        </cl-work-page-header-content>
      </cl-work-page-header>
      <cl-work-page-content>
        <div style="padding: 10px">
          @if (visible === true) {
            <p>
              {{ 'globals/accessTokenDenied' | translate }}
            </p>
          }
        </div>
      </cl-work-page-content>
    </cl-work-page>
  </dx-popup>
}
<router-outlet></router-outlet>
<cl-export-task-panel></cl-export-task-panel>
